(function() {
  function fixVariantPicker() {
    var VariantSelects = customElements.get('variant-selects');
    if (!VariantSelects) {
      setTimeout(fixVariantPicker, 100);
      return;
    }
    VariantSelects.prototype.updateOptions = function() {
      var selectedOptions = [];
      this.querySelectorAll('.product-form__input').forEach(function(container) {
        var selectEl = container.querySelector('select');
        if (selectEl) {
          selectedOptions.push(selectEl.value);
          return;
        }
        var checkedInput = container.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          selectedOptions.push(checkedInput.value);
        }
      });
      this.options = selectedOptions;
    };
  }
  fixVariantPicker();
})();
